import { useState, useEffect } from 'react';
import './Season.scss';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import PlanetLinks from '../../../components/PlanetLinks/PlanetLinks';
import city from '../../../city.json'

const Season = () => {
  const [year, setYear] = useState(2025);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [location, setLocation] = useState("Kolkata");
  const [timeFormat, setTimeFormat] = useState("12");
  const [seasonData, setSeasonData] = useState(null);


const [tempLocation, setTempLocation] = useState("Kolkata");
const [suggestions, setSuggestions] = useState([]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  useEffect(() => {
    const fetchSeasonData = async () => {
      try {
        const response = await fetch(`https://core-c343.onrender.com/api/seasons?year=${year}&locationName=${location}`);
        const data = await response.json();
        setSeasonData(data.seasons);
      } catch (error) {
        console.error("Error fetching seasons:", error);
      }
    };

    fetchSeasonData();
  }, [year, location]);


  

const formatTime = (timeStr, formatType) => {
  if (!timeStr || typeof timeStr !== "string") return "N/A";

  // If already 24-hour (no AM/PM), return early if needed
  const isAMPM = /AM|PM/i.test(timeStr.trim());

  let [time, modifier] = timeStr.trim().split(/[\s]+/); // Splits "10:00 AM"
  let [hours, minutes] = time.split(":").map(Number);

  if (isNaN(hours) || isNaN(minutes)) return "N/A";

  // Convert to 24-hour if it's in 12-hour format
  if (isAMPM) {
    modifier = modifier.toUpperCase();
    if (modifier === "PM" && hours < 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;
  }

  // Format output based on desired format
  if (formatType === "12") {
    const suffix = hours >= 12 ? "PM" : "AM";
    const hour12 = hours % 12 || 12;
    return `${String(hour12).padStart(2, "0")}:${String(minutes).padStart(2, "0")} ${suffix}`;
  } else if (formatType === "24") {
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  } else {
    // 24Plus – return raw string
    return timeStr;
  }
};


  const formattedDate = currentDate.toISOString().split("T")[0];

  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };

    const handleChange = (e) => {
      const value = e.target.value;
      setTempLocation(value);
  
      // filter cities when user types
      if (value.length > 0) {
        const filtered = city.filter((c) =>
          c.city.toLowerCase().includes(value.toLowerCase())
        );
        setSuggestions(filtered.slice(0, 4)); // show only first 4 results
      } else {
        setSuggestions([]);
      }
    };
  
    const handleSelect = (cityName) => {
      setTempLocation(cityName);
      setSuggestions([]);
    };

  return (
    <div className="Season-container">
      <InnerNav />
      <div className="Season-content">
        <Zodiac />

        <div className="controls">
          <div className="mode-toggle">
            <button onClick={() => setTimeFormat("12")} className={timeFormat === "12" ? "active" : ""}>12 Hour</button>
            <button onClick={() => setTimeFormat("24")} className={timeFormat === "24" ? "active" : ""}>24 Hour</button>
            <button onClick={() => setTimeFormat("24Plus")} className={timeFormat === "24Plus" ? "active" : ""}>24 Plus</button>
          </div>

          

          <div className="location-date">
            <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
            <input type="number" value={year} onChange={handleYearInput} />
            <button onClick={() => changeYear(-1)}>Prev Year</button>
            <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
            <button onClick={() => changeYear(1)}>Next Year</button>
          </div>
        </div>

        <h1 className="season-heading">{year} Seasons for {location}</h1>

        {seasonData ? (
          Object.entries(seasonData).map(([seasonName, details], index) => (
            <div className="sankranti-card" key={index}>
              <div className="card-body">
                <div className="date-box">
                  <div className="date">{details.date.split(" ")[1]}</div>
                  <div className="month-year">{details.date}</div>
                  <div className="weekday">{details.day}</div>
                </div>
                <div className="s-details">
                  <div className="s-tithi"><strong>{seasonName}</strong></div>
                  <ul className="s-festivals">
                    {/* <li>Timezone: {details.timezone}</li> */}
                    <li>Latitude: {details.coordinates.lat}</li>
                    <li>Longitude: {details.coordinates.lon}</li>
                  </ul>
                  <div className="s-timings">
                    Starts at {formatTime(details.time, timeFormat)}
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>Loading season data...</p>
        )}

        <PlanetLinks />
      </div>
      <Footer />
    </div>
  );
};

export default Season;
